import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'filterUnit',
    pure: true
  })
  export class FilterUnitPipe implements PipeTransform {
    transform(value: any, onlyAvailable?: any, onlyPromotion?: any, blockId? :any): any {

        if(value instanceof Array){
            let ret:any = value;

            if(blockId && value[blockId] instanceof Array){
                ret = [value[blockId]];
            } else if(blockId){
                ret = [ret.filter(item => item.blockId == blockId)[0]];
            }

            if(blockId && typeof ret[0] === 'undefined')
                return [];
            
            ret = ret.map(block => {
                block = block.map(item => {
                    if(onlyAvailable){
                        item = item.filter(item => item.status == 11);
                    }
        
                    if(onlyPromotion){
                        item = item.filter(item => item.status == 11 && item.amountOld > item.amount);
                    }                        
                    return item;
                }).filter(item => !!item.length);
                return block;
            }).filter(item => !!item.length);
            
            if(blockId)
                return !!ret[0]?.length? ret[0] : [];

            return ret;
        }
        
        let units = [];
        for(const field in value){
            if(value.hasOwnProperty(field)){
                units = units.concat(this.transform(value[field], onlyAvailable, onlyPromotion, blockId));
            }
        }


        return units;
        
    }
  
  }